export default "__VITE_ASSET__CbP_5gg7__"